import DataLoader from 'components/DataLoader';
import WindowResizeWatcher from 'components/WindowResizeWatcher';
import Component from 'containers/OldNewWordsFrame/Component';
import React, {FC} from 'react';
import {getDataUrl} from 'utils/dataUrls';
import {makeReadConfigurator} from 'utils/makeConfigurator';

export type Data = {
  svg: string;
};

export type TestProps = {
  forceMobile?: boolean;
};

const OldNewWordsFrame: FC<TestProps> = (testProps: TestProps) => {
  return (
    <WindowResizeWatcher>
      {({width, height, isMobile, mobileMaxW}) => {
        const isMobile1 = testProps.forceMobile ?? isMobile;
        const conf = makeReadConfigurator({
          width,
          height,
          isMobile: isMobile1,
          mobileMaxW,
        });
        return (
          <DataLoader<Data>
            urls={{
              svg: getDataUrl(
                `./figma-svg/${isMobile1 ? `old_new_words.mobile.svg` : `old_new_words.svg`}`,
              ),
            }}
          >
            {(data: Data) => <Component data={data} conf={conf} />}
          </DataLoader>
        );
      }}
    </WindowResizeWatcher>
  );
};

export default OldNewWordsFrame;
